import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import { CustomModal } from 'commons-ui';
import AuthorizedRoute from '../../../permission/AuthorizedRoute';
import { PAGE_NAMES, SETTINGS_V2_ACTION, SETTINGS_V2_RESOURCES } from '../../../settingsV2Constant';

import EditUser from './submodules/edit';
import ListUser from './submodules/list';
import CreateUser from './submodules/create';

const UserManagementDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.settingsV2}
				configResourceName={SETTINGS_V2_RESOURCES.user}
				configActionName={SETTINGS_V2_ACTION.listUsers}
				exact
				path={`${path}/list`}
				component={ListUser}
			/>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.settingsV2}
				configResourceName={SETTINGS_V2_RESOURCES.user}
				configActionName={SETTINGS_V2_ACTION.createUser}
				exact
				path={`${path}/create`}
				component={CreateUser}
			/>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.settingsV2}
				configResourceName={SETTINGS_V2_RESOURCES.user}
				configActionName={SETTINGS_V2_ACTION.editUser}
				exact
				path={`${path}/edit`}
				component={EditUser}
			/>
			<Redirect to={`${path}/list`} />
			<CustomModal />
		</Switch>
	);
};

export default UserManagementDashboard;
